import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SHOW_MESSAGE,
  GET_DROPZZ_VERIFICATIONS,
  GET_DROPZZ_VERIFICATION_ITEM,
  SET_DROPZZ_VERIFICATION_PAGE,
  SET_DROPZZ_VERIFICATION_STATUS,
} from '../../shared/constants/ActionTypes';
import jwtAxios from '@crema/services/auth/jwt-auth/jwt-api';
import {
  getDropzzErrorMessage,
  normalizeDropzzItem,
  normalizeDropzzList,
} from 'pages/admin/Dropzz/dropzzUtils';

const GENERIC_ERROR = 'Something went wrong, Please try again!';

const isHttpOk = (status) => status === 200 || status === 201 || status === 204;

const handleApiFailure = (dispatch, payload) => {
  if (payload?.succeeded === false) {
    const errors = Array.isArray(payload?.errors)
      ? payload.errors.filter(Boolean).join(' ')
      : '';
    dispatch({
      type: FETCH_ERROR,
      payload: errors || payload?.message || GENERIC_ERROR,
    });
    return true;
  }
  return false;
};

export const setDropzzVerificationPage = (page) => ({
  type: SET_DROPZZ_VERIFICATION_PAGE,
  payload: page,
});

export const setDropzzVerificationStatus = (status) => ({
  type: SET_DROPZZ_VERIFICATION_STATUS,
  payload: status,
});

export const getDropzzVerifications = (limit = 10) => {
  return (dispatch, getState) => {
    const {page, status} = getState().dropzzVerification;
    const params = {
      pageNo: page,
      pageSize: limit,
    };
    if (status !== '' && status !== null && status !== undefined) {
      params.status = status;
    }
    dispatch({type: FETCH_START});
    jwtAxios
      .get('/dropzz/verifications', {params})
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: GET_DROPZZ_VERIFICATIONS,
            payload: normalizeDropzzList(res.data),
          });
        } else {
          dispatch({type: FETCH_ERROR, payload: GENERIC_ERROR});
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR),
        });
      });
  };
};

export const getDropzzVerificationById = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    return jwtAxios
      .get(`/dropzz/verifications/${id}`)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data)) {
            return null;
          }
          const item = normalizeDropzzItem(res.data);
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: GET_DROPZZ_VERIFICATION_ITEM,
            payload: item,
          });
          return item;
        }
        dispatch({type: FETCH_ERROR, payload: GENERIC_ERROR});
        return null;
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR),
        });
        return null;
      });
  };
};

export const approveDropzzVerification = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post(`/dropzz/verifications/${id}/approve`)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzVerifications());
        } else {
          dispatch({type: FETCH_ERROR, payload: GENERIC_ERROR});
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR),
        });
      });
  };
};

export const rejectDropzzVerification = (id, body) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post(`/dropzz/verifications/${id}/reject`, body)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzVerifications());
        } else {
          dispatch({type: FETCH_ERROR, payload: GENERIC_ERROR});
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR),
        });
      });
  };
};
